import React, { useEffect, useState } from 'react';
import { toastr } from 'react-redux-toastr';
import api from '../../../api';
import { useForm } from 'react-hook-form';
import 'bootstrap/dist/css/bootstrap.min.css';
import ContainerLoader from '../../loader/container-loader';
import styles from '../../wallOfFrame/wallOfFrame.module.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Form, Button } from 'react-bootstrap';
import { trackEvent } from '../../../utils/gaTracking';

const MarketingInsightsForm = () => {
    const [isfetching, setIsfetching] = useState(false);
    const [showForm, setShowForm] = useState(true);
    const location = useLocation();
    const navigate = useNavigate();

    const { state } = location;
    const initialData = state?.initialData || {};
    const currentId = state?.currentId || null;
    const isEdit = state?.isEdit || false;

    const authState = useSelector((state) => state.authUser);
    // const role_id = authState?.profile?.role?.role_id;
    const userRoles = authState?.userRoles || [];
    const hasRole = (roleId) => userRoles.some(role => role.role_id === roleId);
    const user_id = authState?.profile?.user_id;
    const user_email = authState?.profile?.email;

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        setValue,
    } = useForm();

    useEffect(() => {
        if (initialData) {
            Object.keys(initialData).forEach((key) => {
                setValue(key, key === 'isactive' ? (initialData.isactive ? '1' : '2') : initialData[key]);
            });
        }
    }, [initialData, setValue]);

    const handleData = async (formData) => {
        try {
            setIsfetching(true);
            setShowForm(false);


            if (!api?.insight) {
                throw new Error("API service (api.insight) is undefined. Check initialization.");
            }

            const request = isEdit
                ? { resource: `api/marketinginsights/${currentId}` }
                : { resource: 'api/marketinginsights' };


            const apiMethod = isEdit
                ? api.insight.updateDetails.bind(api.insight)
                : api.insight.addDetails.bind(api.insight);

            const response = await apiMethod(request, {
                ...formData,
                isactive: formData.status === '1',
            });


            if (response?.data?.status === 200) {
                toastr.success('Success', isEdit ? 'Record updated successfully!' : 'Record added successfully!');
                trackEvent(`admin_mh_marketing_insights_${isEdit ? 'update': 'add'}`, `Admin Marketing Hub Marketing Insights ${isEdit ? 'Update': 'Add'}`, `Admin Marketing Hub Marketing Insights ${isEdit ? 'Update': 'Add'}`, 1, user_id, user_email);
                navigate('/manageMarketingInsights');
            } else {
                toastr.error('Error', response?.data?.message || 'Something went wrong');
            }
        } catch (error) {
            console.error("API Error:", error);
            toastr.error('Error', 'Failed to save data');
        } finally {
            setIsfetching(false);
            setShowForm(true);

            if (!isEdit) {
                reset();
            }
        }
    };

    useEffect(() => {
        if (!hasRole(13) && !hasRole(6)) {
            navigate('/marketingHub');
        }
    }, [userRoles, navigate]);

    return (
        <div className={`${styles.dataTableWrapper} ${styles.formWrapper} mx-auto p-2`}>
            <h4 className="my-4 pagetitle">Marketing Insights Form</h4>
            {isfetching && <ContainerLoader />}
            {showForm && (
                <div className='row'>
                    <div className='col-12'>
                        <div className='walloffame_form w-sm-100 mx-auto'>
                            <Form onSubmit={handleSubmit(handleData)} className="d-flex flex-wrap justify-content-between">
                                <div className='col-12 p-2'>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Title<span className='text-danger'>*</span></Form.Label>
                                        <Form.Control
                                            type='text'
                                            {...register('title', {
                                                required: 'Title is required',
                                                validate: (value) => isNaN(value) || 'Title cannot be only numbers',
                                            })}
                                        />
                                        {errors.title && <p style={{ color: 'red' }}>{errors.title.message}</p>}

                                    </Form.Group>
                                </div>

                                <div className='col-12 p-2'>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Image URL<span className='text-danger'>*</span></Form.Label>
                                        <Form.Control
                                            type='text'
                                            {...register('imageurl', { required: 'Image URL is required' })}
                                        />
                                        {errors.imageurl && <p style={{ color: 'red' }}>{errors.imageurl.message}</p>}
                                    </Form.Group>
                                </div>

                                <div className='col-12 p-2'>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Redirect URL<span className='text-danger'>*</span></Form.Label>
                                        <Form.Control
                                            type='text'
                                            {...register('redirecturl', { required: 'Redirect URL is required' })}
                                        />
                                        {errors.redirecturl && <p style={{ color: 'red' }}>{errors.redirecturl.message}</p>}
                                    </Form.Group>
                                </div>

                                <div className='col-12 col-md-6 p-2'>
                                    <Form.Group>
                                        <Form.Label>Status<span className='text-danger'>*</span></Form.Label>
                                        <Form.Select
                                            {...register('status', { required: 'Status is required' })}
                                            className="mb-0"
                                        >
                                            <option value="">Select Status</option>
                                            <option value='1'>Active</option>
                                            <option value='2'>Inactive</option>
                                        </Form.Select>
                                        {errors.status && <p style={{ color: 'red' }}>{errors.status.message}</p>}
                                    </Form.Group>
                                </div>
                                <div className='col-12 col-md-6 p-2'>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Type<span className='text-danger'>*</span></Form.Label>
                                        <Form.Select
                                            {...register('type', { required: 'Type is required' })}
                                            className="mb-0"
                                        >
                                            <option value="">Select Type</option>
                                            <option value="blog">Blog</option>
                                            <option value="case study">Case Study</option>
                                            <option value="white paper">White Paper</option>
                                        </Form.Select>
                                        {errors.type && <p style={{ color: 'red' }}>{errors.type.message}</p>}
                                    </Form.Group>
                                </div>

                                <div className='d-flex justify-content-end col-12 p-2'>
                                    <Button variant="secondary" className='me-2' onClick={() => navigate('/manageMarketingInsights')}>
                                        Cancel
                                    </Button>
                                    <Button type="reset" variant="secondary" className='mx-2' onClick={() => reset()}>
                                        Reset
                                    </Button>
                                    <Button type="submit" variant="primary" className='ms-2'>
                                        Save
                                    </Button>
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default MarketingInsightsForm;
